import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=56ed40b3&scoped=true&"
import script from "./DemoPage.vue?vue&type=script&lang=js&"
export * from "./DemoPage.vue?vue&type=script&lang=js&"
import style0 from "./DemoPage.vue?vue&type=style&index=0&id=56ed40b3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed40b3",
  null
  
)

export default component.exports